import {
  PRESCRIPTION_TYPE_TO_PRICE_TYPE,
  PRODUCT_TEMPLATES,
} from 'shared/consts/productTemplates'
import { TENANT_COM } from 'shared/consts/tenants'
import { getPriceForType } from 'shared/utils/productTemplateUtils'

export const getBonus = (prices, prescriptionType) => {
  const price = getPriceForType(
    prices,
    PRESCRIPTION_TYPE_TO_PRICE_TYPE[prescriptionType]
  )

  return price?.bonus ? price.bonus : 0
}

export const isErxLifestyleProduct = product =>
  product?.substitutionOutcome?.substitutionReason === 'lifestyle'

export const isContraceptive = (tenant, productTemplate, product) => {
  return (
    tenant === TENANT_COM &&
    productTemplate === PRODUCT_TEMPLATES.RX &&
    !!product?.isContraceptive
  )
}
